import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import App from './App.vue'
import router from './router/router'
import {store} from './store/store'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css';
import VCalendar from 'v-calendar';
import underscore from 'vue-underscore';
import ImageUploader from 'vue-image-upload-resize'

import objNoImage from '@/assets/noImage.png';
import VuePullInfiniteScroller from 'vue-pull-infinite-scroller'
import VueSocketIO from 'vue-socket.io';

Vue.config.productionTip = false;

Vue.use(ImageUploader);
Vue.use(BootstrapVue);
Vue.use(Vuesax);
Vue.use(VCalendar, {
    locales: {
        'en': {
            firstDayOfWeek: 1,
            masks: {
                L: 'WWW DD MMM YYYY',
            }
        }
    }
});
Vue.use(require('vue-moment'));
Vue.use(underscore);
Vue.use(VuePullInfiniteScroller);
Vue.mixin({
    data() {
        return {
            noImage: objNoImage,
        }
    },
    methods: {
        apply_no_image(e) {
            e.target.src = this.noImage;
        }
    }
});

// Custom - SCSS
import '@/assets/styles/general.scss';
import '@/assets/styles/override.scss';
import '@/assets/styles/elements.scss';
import '@/assets/styles/section.scss';
import '@/assets/scss/allgrads.scss';

window.Event = new Vue();

Vue.prototype.$interpretersApiUrl = process.env.VUE_APP_API;
Vue.prototype.$apiAllGraduatesUrl = process.env.VUE_APP_API_ALLGRADS_URL + '/';
Vue.prototype.$webSocketsUrl = process.env.VUE_APP_WEBSOCKET_URL;
Vue.prototype.$isDev = process.env.VUE_APP_IS_DEV == 'true';

if (Vue.prototype.$webSocketsUrl && process.env.VUE_APP_IS_WEBSOCKETS=='true') {
	Vue.use(new VueSocketIO({
		debug: !!Vue.prototype.$isDev,
		connection: Vue.prototype.$webSocketsUrl
	}))
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
